import styled from 'styled-components'
import { Text } from 'pcln-design-system'

const StyledText = styled(Text.span)`
  font-size: 20px;
  line-height: 28px;
  textAlign: left;
`

export default StyledText
